// @ts-nocheck
export function flattenStudioChapters(curriculum) {
  return curriculum.days.flatMap((day) => day.chapters.map((chapterItem) => ({ day, chapter: chapterItem })));
}
